var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1439.999,
    height: 56.653,
    viewBox: "0 0 1439.999 56.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    transform: "translate(0 -1168.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11572",
    "data-name": "Path 11572",
    d: "M13553-1697.89h1100.683",
    transform: "translate(-13553 2900)",
    fill: "none",
    stroke: "#701FFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11573",
    "data-name": "Path 11573",
    d: "M13553-1697.89h180.283",
    transform: "translate(-12293.284 2900)",
    fill: "none",
    stroke: "#701FFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "matrix(-0.485, 0.875, -0.875, -0.485, 1263.716, 1186.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M17.609,16.875,13.573,0,0,6.236Z",
    transform: "translate(40.866 39.929)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M4.035,0,.367,7.337,0,.734Z",
    transform: "translate(26.78 38.519)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M5.319,1.834,3.668,7.52,0,0Z",
    transform: "translate(57.957 64.786)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M5.87,2.935,0,0,3.3,7.7Z",
    transform: "translate(36.959 24.01)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M23.662,8.8,9.721,18.342,0,0Z",
    transform: "translate(18.893 3.118)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M13.023,12.106,6.42,0,0,21.644Z",
    transform: "translate(0 14.674)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M5.319,1.1,4.035,5.136,0,0Z",
    transform: "translate(11.189 16.325)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M3.118,4.035,2.568,0,0,5.319Z",
    transform: "translate(44.389 68.784)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M8.747,0,6.62,10.166,0,10.639Z",
    transform: "translate(33.136 66.216)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M9.538,2.751,0,0,3.118,14.49Z",
    transform: "translate(44.205 92.812)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M20.543,0,16.692,33.933,0,14.124Z",
    transform: "translate(67.133 104.918)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M1.622,0l9.326,6.285L0,19.259Z",
    transform: "translate(68.682 90.074)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M5.5,4.586,8.8,0,0,.917Z",
    transform: "translate(56.678 83.091)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M3.668,1.651l-1.284,5.5L0,0Z",
    transform: "translate(67.226 47.359)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M3.3,2.018.367,0,0,7.7Z",
    transform: "translate(60.53 116.657)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M6.6,0,0,1.284l4.4,6.6Z",
    transform: "translate(29.348 58.696)",
    fill: "#701FFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsvg);
export default __webpack_public_path__ + "static/media/websvg.ea46ef89888be56c674764276b36c8ed.svg";
export { ForwardRef as ReactComponent };